export const inputClass =
  "w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm text-black placeholder-gray-400 focus:outline-none focus:border-black focus:bg-white transition-all duration-200";

export const labelClass =
  "block text-xs font-semibold text-gray-500 uppercase tracking-widest mb-1.5";

